"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padZero = void 0;
exports.padZero = function (num, width) {
    var z = '0';
    var n = "" + num;
    // tslint:disable-next-line:prefer-array-literal
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};
